import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, Globe } from "lucide-react";
import gprLogo from "@/assets/gpr-logo.png";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={gprLogo} alt="GPR Infra Logo" loading="lazy" width="48" height="48" className="h-12 w-12" />
              <h3 className="text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                GPR INFRA
              </h3>
            </div>
            <p className="text-muted-foreground mb-4">
              One plot for every family. Building dreams, creating wealth.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/profile.php?id=61566137186385" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Follow us on Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/gprinfra" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Follow us on Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.youtube.com/@offersonopenplots" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Subscribe to our YouTube channel">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">
                About Us
              </Link>
              <Link to="/projects" className="text-muted-foreground hover:text-primary transition-colors">
                Projects
              </Link>
              <Link to="/agent-partner" className="text-muted-foreground hover:text-primary transition-colors">
                Agent Partner Program
              </Link>
              <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Projects */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Our Projects</h4>
            <div className="flex flex-col gap-2">
              <Link to="/projects/gpr-exotica" className="text-muted-foreground hover:text-primary transition-colors">
                GPR Exotica
              </Link>
              <Link to="/projects" className="text-muted-foreground hover:text-primary transition-colors">
                View All Projects
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Contact Us</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-2 text-muted-foreground">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  Sri Vishnu Complex, 4th Floor, B-Block,<br />
                  Opp: Indra Nagendra Theatre, Kharmanghat,<br />
                  Hyderabad, Telangana 500035
                </span>
              </div>
              <div className="flex items-start gap-2 text-muted-foreground">
                <Phone className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <div className="flex flex-col gap-1 text-sm">
                  <a href="tel:8297978080" className="hover:text-primary transition-colors">
                    +91 8297978080
                  </a>
                  <a href="tel:9492083999" className="hover:text-primary transition-colors">
                    +91 9492083999
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-2 text-muted-foreground">
                <Globe className="h-5 w-5 flex-shrink-0" />
                <a href="https://www.gprhyd.com" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-primary transition-colors">
                  www.gprhyd.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-muted-foreground text-sm">
          <p>&copy; {new Date().getFullYear()} GPR Infra. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
